import { ClientItemId } from 'owa-client-ids';
import { action } from 'satcheljs';
import PendingOperationState from '../store/schema/PendingOperationState';
import SxSExtendedViewState from '../store/schema/SxSExtendedViewState';
import SxSReadingPaneState from '../store/schema/SxSReadingPaneState';
import { SxSCustomization } from '../store/schema/SxSStore';

export const closeComposeInSxS = action('closeComposeInSxS', (composeViewState: any) => ({
    composeViewState,
}));

export const editAndReply = action(
    'editAndReply',
    (
        loadDraftToCompose: (itemId: ClientItemId) => Promise<void>,
        createReply: (referenceItemId: ClientItemId) => Promise<ClientItemId>,
        trySaveAndCloseCompose: (conversationId: string) => Promise<ClientItemId>
    ) => ({
        loadDraftToCompose,
        createReply,
        trySaveAndCloseCompose,
    })
);

export const editInDraft = action(
    'editInDraft',
    (loadDraftToCompose: (itemId: ClientItemId) => Promise<void>) => ({
        loadDraftToCompose,
    })
);

export const forceCloseSxS = action('forceCloseSxS', (closingSource: string) => ({
    closingSource,
}));

export const openComposeInSxS = action('openComposeInSxS', (composeViewState: any) => ({
    composeViewState,
}));

export const tryCloseSxS = action('tryCloseSxS', (closingSource: string) => ({
    closingSource,
}));

export const tryExitSxSEditMode = action('tryExitSxSEditMode');

export const showSxS = action(
    'showSxS',
    (
        customization: SxSCustomization,
        extendedViewState: SxSExtendedViewState,
        editState: {
            editAllowed: boolean;
            itemId: ClientItemId;
            isDraft: boolean;
        },
        selectedLinkId: string
    ) => ({
        customization,
        extendedViewState,
        editState,
        selectedLinkId,
    })
);

export const onSxSReadingPaneChange = action(
    'onSxSReadingPaneChange',
    (readingPaneState: SxSReadingPaneState) => ({
        readingPaneState,
    })
);

export const onPreviewOperationStart = action(
    'onPreviewOperationStart',
    (pendingPreviewOperation: PendingOperationState) => ({
        pendingPreviewOperation,
    })
);

export const onPreviewOperationFinished = action('onPreviewOperationFinished');

export const onPendingNavigation = action('onPendingNavigation', (attachmentId: string) => ({
    attachmentId,
}));

export const onChangeByImageGallery = action('onChangeByImageGallery');

export const onShowCustomPreview = action('onShowCustomPreview', (customPreviewState: any) => ({
    customPreviewState,
}));

export const saveToCloud = action('saveToCloud', (entryPoint: string) => ({
    entryPoint,
}));

export const openSxSInANewWindow = action(
    'openSxSInANewWindow',
    (parentItemId: ClientItemId, attachmentId: string, isEdit: boolean) => ({
        parentItemId,
        attachmentId,
        isEdit,
    })
);

export const reloadReadingPaneAfterClosingSxS = action('reloadReadingPaneAfterClosingSxS');

export const onSxSChangeOrClose = action(
    'onSxSChangeOrClose',
    (selectedLinkId: string | null, isSelectedLinkReadOnly?: boolean) => ({
        selectedLinkId,
        isSelectedLinkReadOnly,
    })
);
